import { init } from '@sentry/browser';

import { getEnvVar } from './getEnvVar';

export function initSentry() {
    const dsn = getEnvVar('SENTRY_DSN');
    const env = getEnvVar('CLUSTER_NAME');

    const release = process.env.SENTRY_RELEASE;

    if (!release) {
        return;
    }

    if (!dsn || !env) {
        console.warn(`root: failed to init sentry for dsn: ${dsn}, env: ${env}`);
        return;
    }

    init({
        dsn,
        release,
        environment: env,

        normalizeDepth: 10,
        maxValueLength: 1000,

        autoSessionTracking: false,
        defaultIntegrations: false,
    });
}
